var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useLayoutEffect } from 'react';
import { createControllerBox, Schema } from '@formily/react-schema-renderer';
import { toArr } from '@formily/shared';
import { version } from 'antd';
import { AntdSchemaFieldAdaptor, pickFormItemProps } from '@formily/antd';
import styled from 'styled-components';
var isV4 = /^4\./.test(version);
export var FormTextBox = createControllerBox('text-box', styled(function (_a) {
    var props = _a.props, form = _a.form, className = _a.className, children = _a.children;
    var schema = new Schema(props);
    var mergeProps = schema.getExtendsComponentProps();
    var _b = Object.assign({
        gutter: 5
    }, mergeProps), title = _b.title, label = _b.label, text = _b.text, gutter = _b.gutter, style = _b.style;
    var formItemProps = pickFormItemProps(mergeProps);
    var ref = useRef();
    var arrChildren = toArr(children);
    var split = text.split('%s');
    var index = 0;
    useLayoutEffect(function () {
        if (ref.current) {
            var elements = ref.current.querySelectorAll('.text-box-field');
            var syncLayouts_1 = Array.prototype.map.call(elements, function (el) {
                return [
                    el,
                    function () {
                        var ctrl = el.querySelector('.ant-form-item-children');
                        setTimeout(function () {
                            if (ctrl) {
                                var editable = form.getFormState(function (state) { return state.editable; });
                                el.style.width = editable
                                    ? ctrl.getBoundingClientRect().width + 'px'
                                    : 'auto';
                            }
                        });
                    }
                ];
            });
            syncLayouts_1.forEach(function (_a) {
                var el = _a[0], handler = _a[1];
                handler();
                el.addEventListener('DOMSubtreeModified', handler);
            });
            return function () {
                syncLayouts_1.forEach(function (_a) {
                    var el = _a[0], handler = _a[1];
                    el.removeEventListener('DOMSubtreeModified', handler);
                });
            };
        }
    }, []);
    var newChildren = split.reduce(function (buf, item, key) {
        return buf.concat(item ? (React.createElement("p", { key: index++, className: "text-box-words", style: __assign({ marginRight: gutter / 2, marginLeft: gutter / 2 }, style) }, item)) : null, arrChildren[key] ? (React.createElement("div", { key: index++, className: "text-box-field" }, arrChildren[key])) : null);
    }, []);
    var textChildren = (React.createElement("div", { className: className + " " + mergeProps.className, style: {
            marginRight: -gutter / 2,
            marginLeft: -gutter / 2
        }, ref: ref }, newChildren));
    if (!title && !label)
        return textChildren;
    return (React.createElement(AntdSchemaFieldAdaptor, __assign({}, formItemProps), textChildren));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    .text-box-words:nth-child(1) {\n      margin-left: 0;\n    }\n    .text-box-words {\n      margin-bottom: 0 !important;\n      ", "\n    }\n    .text-box-field {\n      display: inline-block;\n      .ant-form-item {\n        margin-bottom: 0 !important;\n      }\n    }\n    .next-form-item {\n      margin-bottom: 0 !important;\n    }\n    .preview-text {\n      text-align: center !important;\n    }\n  "], ["\n    display: flex;\n    .text-box-words:nth-child(1) {\n      margin-left: 0;\n    }\n    .text-box-words {\n      margin-bottom: 0 !important;\n      ", "\n    }\n    .text-box-field {\n      display: inline-block;\n      .ant-form-item {\n        margin-bottom: 0 !important;\n      }\n    }\n    .next-form-item {\n      margin-bottom: 0 !important;\n    }\n    .preview-text {\n      text-align: center !important;\n    }\n  "])), isV4 ? 'line-height:32px' : ''));
export default FormTextBox;
var templateObject_1;
